import axios from "axios";
import { BASE_URL } from "../Utils/base_url";
const LoginSocieteRequest = async (data) => {
    return await axios.post(`${BASE_URL}/loginSociete`, data);
}
export { LoginSocieteRequest };